import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/users'

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response?.data
}

const baseEndpointV2 = '/user'

export const getV2 = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpointV2}`,
    params: params,
  })

  return response?.data
}

export const getTechnicians = async (queryParam) => {
  const params = {
    filters: queryParam?.filters || undefined,
  }
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/technician`,
    params: params,
  })

  return response?.data
}

/**
 * Save technician address profile
 */
export const saveAddress = async (userId, payload) => {
  const response = await apiClient({
    method: 'PUT',
    url: `${baseEndpoint}/${userId}/addresses`,
    data: payload,
  })

  return response?.data
}

export const getAddress = async (userId) => {
  const response = await apiClient({
    method: 'PUT',
    url: `${baseEndpoint}/${userId}/addresses`,
  })

  return response?.data
}
